import { Outlet, Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Users, Activity, ArrowLeft } from 'lucide-react';
import { ROUTES } from '@traction/shared';
import { classNames } from '@traction/shared';

const adminNavigation = [
  { name: 'Overview', href: ROUTES.ADMIN, icon: LayoutDashboard },
  { name: 'Users', href: ROUTES.ADMIN_USERS, icon: Users },
  { name: 'Agents', href: ROUTES.ADMIN_AGENTS, icon: Activity },
];

export function AdminLayout() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex">
      <aside className="w-64 border-r border-gray-200 bg-gray-900">
        <div className="flex h-16 items-center border-b border-gray-800 px-6">
          <span className="text-xl font-semibold text-white">Admin</span>
        </div>

        <nav className="flex flex-col gap-1 p-4">
          <Link
            to={ROUTES.DASHBOARD}
            className="mb-4 flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium text-gray-400 hover:bg-gray-800 hover:text-white"
          >
            <ArrowLeft className="h-5 w-5" />
            Back to app
          </Link>

          {adminNavigation.map((item) => {
            const isActive =
              item.href === ROUTES.ADMIN
                ? location.pathname === ROUTES.ADMIN
                : location.pathname.startsWith(item.href);
            return (
              <Link
                key={item.name}
                to={item.href}
                className={classNames(
                  'flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium',
                  isActive
                    ? 'bg-white text-gray-900'
                    : 'text-gray-400 hover:bg-gray-800 hover:text-white'
                )}
              >
                <item.icon className="h-5 w-5" />
                {item.name}
              </Link>
            );
          })}
        </nav>
      </aside>

      <main className="flex-1 overflow-auto bg-gray-50">
        <Outlet />
      </main>
    </div>
  );
}
